import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=5a6fe27e"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6fe27e')) {
      api.createRecord('5a6fe27e', component.options)
    } else {
      api.reload('5a6fe27e', component.options)
    }
    module.hot.accept("./Teacher.vue?vue&type=template&id=5a6fe27e", function () {
      api.rerender('5a6fe27e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/find/Teacher.vue"
export default component.exports